<script>
  import { onMount } from 'svelte';
  import { tools, solutions } from './constants.js';

  export let skip = '';
  let showTools = {};

  onMount(() => {
    showTools = {...tools};
    if (skip != '') {
      if (showTools[skip] != undefined) {
        delete showTools[skip];
      }
    }
  });
</script>

<div class="side-box">
  <h6 class="mb-5 font-weight-bold">MORE EMAIL SECURITY TOOLS FROM FORTRA</h6>
  {#each Object.entries(showTools) as [key, tool]}
    <div class="mb-5">
      <h6 class="font-weight-bold">{tool.title}</h6>
      <p>{tool.text}</p>
      <a href="{tool.link}" class="link-arrow purple-arrow" title="{tool.linkTitle}">{tool.linkText}</a>
    </div>
  {/each}
</div>

<style>

</style>
